import type {ParsedPaymentPlan, PaymentPlan} from './types';

import {Currency, extractCommission, getPriceString} from '../../../money';
import {DefaultPaymentPlan} from './constants';
import {getAverageMonthlyPayment} from './getAverageMonthlyPayment';
import {getMonthlyPaymentPerUnitString} from './getMonthlyPaymentPerUnitString';
import {ProgramPaymentTypeEnum} from './programPaymentTypeEnum';

export const parsePaymentPlan = (
  paymentPlan: null | PaymentPlan = DefaultPaymentPlan,
): PaymentPlan & ParsedPaymentPlan => {
  const _paymentPlan = {
    ...DefaultPaymentPlan,
    ...paymentPlan,
  };

  const paymentType =
    _paymentPlan.schedule.length > 1 && _paymentPlan.total > 0
      ? ProgramPaymentTypeEnum.MONTHLY
      : ProgramPaymentTypeEnum.ONE_TIME;

  const monthlyPayment =
    paymentType.id === ProgramPaymentTypeEnum.MONTHLY.id
      ? getAverageMonthlyPayment(
          _paymentPlan.total,
          _paymentPlan.schedule.length,
        )
      : 0;

  const extractedCommissionTotal =
    _paymentPlan.total > 0
      ? _paymentPlan.total - extractCommission(_paymentPlan.total)
      : _paymentPlan.total;
  const extractedCommissionMonthlyPayment =
    monthlyPayment > 0
      ? monthlyPayment - extractCommission(monthlyPayment)
      : monthlyPayment;

  return {
    ..._paymentPlan,
    extractedCommission: {
      monthlyPayment: extractedCommissionMonthlyPayment,
      schedule: _paymentPlan.schedule.map(item => ({
        ...item,
        amount: item.amount - extractCommission(item.amount),
      })),
      toString: () =>
        paymentType.id === ProgramPaymentTypeEnum.MONTHLY.id
          ? `${getPriceString({
              currency: Currency[_paymentPlan.currency],
              price: extractedCommissionMonthlyPayment,
            })}${getMonthlyPaymentPerUnitString().toLowerCase()}`
          : getPriceString({
              currency: Currency[_paymentPlan.currency],
              price: extractedCommissionTotal,
            }),
      total: extractedCommissionTotal,
    },
    monthlyPayment,
    parsedCurrency: Currency[_paymentPlan.currency],
    paymentType,
    toString: () =>
      paymentType.id === ProgramPaymentTypeEnum.MONTHLY.id
        ? `${getPriceString({
            currency: Currency[_paymentPlan.currency],
            price: monthlyPayment,
          })}${getMonthlyPaymentPerUnitString().toLowerCase()}`
        : getPriceString({
            currency: Currency[_paymentPlan.currency],
            price: _paymentPlan.total,
          }),
  };
};
